import { wrap } from '../utils/promise';
import { Host } from './host';
import {type} from '../utils/common';
import internalContributes from './contributes/index';  //内置的贡献处理器

let host;
export function init(){ //初始化扩展程序
    return wrap((resolve, reject) => {
        import('project/extension/config').then((config)=>{ //插件的配置路径是死的，跟package.json一样，不需要配置
            let {plugins,contributes} = config.default;
            host = new Host();
            host.register(plugins); //注册插件
            host.contribute().register([...internalContributes,...contributes]);    //注册贡献点的处理程序
            resolve();
        });
    });
}

export function registerContext(name,member){   //为上下文注册成员
    host.context().register(name,member);
}

//根据事件，激活插件
export function activate(arg){ //激活插件，event:插件在哪个事件下激活,ids:插件编号的集合
    let argType = type(arg);
    if(argType==="string") return host.activate({event:arg});
    return host.activate({ids:arg});
}

export function filter(predicate){  //过滤插件,如果传递false表示取消过滤
    host.filter(predicate);
}

export function getExtensions(ignoreFilter){  //获得扩展程序,ignoreFilter:是否忽略过滤项
    return host.getPlugins(ignoreFilter);
}

export function getExtension({id,ignoreFilter}){  //获得扩展程序,ignoreFilter:是否忽略过滤项
    return host.getPlugin({id,ignoreFilter});
}

//获得一个被激活了的插件
export function getInstance(id){  //获得插件被激活后的实例
    return host.runtime().getExtension(id)?.exports;
}


//获得所有的贡献点定义
export function getContributes(){
    return host.contribute().items();
}